import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import rsf from '../../helpers/firebase';
import types from './actionTypes';
import * as actions from './actions';
import { isAdmin as isAdminSelector } from '../../selectors/auth';
import { actualUser } from '../../selectors/user';

const db = getFirestore(rsf.app);

const transformCommission = (snap) => {
  const data = snap.data();

  return {
    id: snap.id,
    ...data,
    createdAt: data.createdAt.toDate(),
    ...(data.updatedAt && { updatedAt: data.updatedAt.toDate() }),
  };
};

function* fetchCommissionsSaga({ startDate, endDate }) {
  try {
    const user = yield select(actualUser);

    const isAdmin = yield select(isAdminSelector);

    let q;
    if (isAdmin) {
      q = query(
        collection(db, 'commissions'),
        where('createdAt', '>=', Timestamp.fromDate(new Date(startDate))),
        where('createdAt', '<=', Timestamp.fromDate(new Date(endDate))),
        orderBy('createdAt', 'desc'),
      );
    } else {
      q = query(
        collection(db, 'commissions'),
        where('affiliateId', '==', user.affiliateId),
        where('createdAt', '>=', Timestamp.fromDate(new Date(startDate))),
        where('createdAt', '<=', Timestamp.fromDate(new Date(endDate))),
        orderBy('createdAt', 'desc'),
      );
    }

    const querySnapshot = yield call(getDocs, q);
    const commissions = querySnapshot.docs.map(transformCommission);

    yield put(actions.fetchCommissionsSuccess(commissions, startDate, endDate));
  } catch (error) {
    console.error('Error fetching commissions:', error);
    yield put(actions.fetchCommissionsFailure(error.message));
  }
}

export default function* commissionSaga() {
  yield takeLatest(types.FETCH_COMMISSIONS.REQUEST, fetchCommissionsSaga);
}
